// extracted by mini-css-extract-plugin
module.exports = {"dash-empty-label":"dash-empty-label__9s7AT","small":"small__RxjXw","medium":"medium__aRvLy","large":"large__tUZ4k"};